<template>
    <tr>

        <td>
            <p>{{operatore.nominativo}}</p>
        </td>
        <td>
            <p>{{operatore.data_login}}</p>
        </td>
        <td>
            <p>{{operatore.last_message}}</p>
        </td>
        <td>
            <p>{{operatore.chat_in_carico}} Chat</p>
        </td>
        <td>
            <button type="button" class="btn btn-sm btn-danger" title="Esegui Logout">
                <ficon :icon="['fa', 'sign-out-alt']" v-on:click="logoutOperatore(operatore.id)"></ficon>
            </button>
        </td>
    </tr>
</template>

<script>

import BackendApi from '../models/BackendApi'

export default {
  name: 'OperatoriItem',
  data: function() {
        return  {
            error_message: false,
        }
  },
  props: ['operatore','callbackHideModal','operatorerId','callbackModalError','callbackModalRemoveError'],
  methods: {
    logoutOperatore: function(id_user) 
    {
        this.callbackModalRemoveError();
        let api = new BackendApi(this.configApp)
        api.logout(id_user,this.operatorerId, (result) => {
            if(result.success == true)
            {
                this.callbackHideModal()
            } else {
                this.callbackModalError()
            }
        })
    }
  }
  
}
</script>